"use client";
import environment from "@/external/ensolvers-core-frontend-mui-v5/submodules/fox-typescript/environment.json";
import environmentPROD from "../environment-prod.json";
import environmentQA from "../environment-qa.json";
import environmentDEV from "../environment.json";

type EnvName = "prod" | "qa" | "dev";

export function getEnvVars() {
  switch (environment.env.toLowerCase() as EnvName) {
    case "dev":
      return environmentDEV;
    case "qa":
      return environmentQA;
    case "prod":
      return environmentPROD;
  }
}

/**
 * Returns true if the current environment name matches one of the values provided in the array.
 *
 * @param envs array containing the environment names
 * @returns true if the current environment is listed in the array
 */
export function envIsOneOf(envs: EnvName[]) {
  return envs.some((e) => e === environment.env.toLowerCase());
}
